import { Injectable, signal } from "@angular/core";

export type ToastType = "success" | "error";

export interface Toast {
  id: string;
  type: ToastType;
  message: string;
}

@Injectable({ providedIn: "root" })
export class ToastService {
  readonly toasts = signal<Toast[]>([]);

  success(message: string): void {
    this.add("success", message);
  }

  error(message: string): void {
    this.add("error", message);
  }

  remove(id: string): void {
    this.toasts.update((items) => items.filter((t) => t.id !== id));
  }

  private add(type: ToastType, message: string): void {
    const id = crypto.randomUUID();
    this.toasts.update((items) => [...items, { id, type, message }]);

    const duration = type === "success" ? 4000 : 6000;
    setTimeout(() => this.remove(id), duration);
  }
}
